module.exports = __webpack_public_path__ + "img/lsShirt-front.87acf18b.svg";